import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c21a303"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "benefit-summary first-widget" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "title" }, "Benefit Summary", -1))
const _hoisted_3 = { class: "accordion-box" }
const _hoisted_4 = {
  key: 0,
  class: "accordion-tab collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#flush-collapseOne",
  "aria-expanded": "false"
}
const _hoisted_5 = { class: "amount-label" }
const _hoisted_6 = { class: "amount-value" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, null, -1))
const _hoisted_8 = {
  class: "accordion-content collapse",
  id: "flush-collapseOne"
}
const _hoisted_9 = { class: "item-label" }
const _hoisted_10 = { class: "item-value" }
const _hoisted_11 = {
  key: 0,
  class: "accordion-item"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label" }, "Convenience Fee", -1))
const _hoisted_13 = { class: "item-value" }
const _hoisted_14 = { class: "accordion-box" }
const _hoisted_15 = {
  class: "accordion-tab collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#flush-collapseOne",
  "aria-expanded": "false"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "amount-label" }, "Monthly Premium", -1))
const _hoisted_17 = { class: "amount-value" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Month", -1))
const _hoisted_19 = {
  class: "accordion-content collapse",
  id: "flush-collapseOne"
}
const _hoisted_20 = { class: "item-label" }
const _hoisted_21 = { class: "item-value" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Month", -1))
const _hoisted_23 = {
  key: 0,
  class: "accordion-item"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label" }, "Convenience Fee", -1))
const _hoisted_25 = { class: "item-value" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Month", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.showBenefitHeader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.benefitHeader), 1),
            _createElementVNode("div", _hoisted_6, " $" + _toDisplayString(_ctx.getTotalPremiumAmount(_ctx.getBenefitRates.amountDueToday, _ctx.isCardChecked)), 1),
            _hoisted_7
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getBenefitRates.amountDuePlanRates, (benefit) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "accordion-item",
            key: 'benefit-' + benefit.benefitPlanName
          }, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(benefit.benefitPlanName), 1),
            _createElementVNode("div", _hoisted_10, "$" + _toDisplayString(_ctx.helper.formatNumber(benefit.rate)), 1)
          ]))
        }), 128)),
        (_ctx.isCardChecked && _ctx.getBenefitRates.amountDuePlanRates.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, " $" + _toDisplayString(_ctx.helper.formatNumber(_ctx.convenienceFee)), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createTextVNode(" $" + _toDisplayString(_ctx.getTotalPremiumAmountMonthly(
              _ctx.getBenefitRates.monthlyPremium,
              _ctx.isCardMpChecked
            )) + "/ ", 1),
          _hoisted_18
        ]),
        _createElementVNode("div", {
          class: "arrow",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleAccordion && _ctx.toggleAccordion(...args)))
        })
      ]),
      _createElementVNode("div", _hoisted_19, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getBenefitRates.monthlyPremiumPlanRates, (benefit) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "accordion-item",
            key: 'benefit-' + benefit.benefitPlanName
          }, [
            _createElementVNode("div", _hoisted_20, _toDisplayString(benefit.benefitPlanName), 1),
            _createElementVNode("div", _hoisted_21, [
              _createTextVNode(" $" + _toDisplayString(_ctx.helper.formatNumber(benefit.rate)) + "/", 1),
              _hoisted_22
            ])
          ]))
        }), 128)),
        (
            _ctx.isCardMpChecked &&
            _ctx.getBenefitRates.monthlyPremiumPlanRates.length > 0
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _createTextVNode(" $" + _toDisplayString(_ctx.helper.formatNumber(_ctx.convenienceFee)) + "/", 1),
                _hoisted_26
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}